//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum OzonProductsTableFilterColumn {
  hasMsProduct = 0,
  isArchived = 1,
  /** Товар с тем же артикулом есть на Wildberries. */
  onWb = 2,
  /** Товар с тем же артикулом есть на Яндекс Маркете. */
  onYandexMarket = 3,
  /** Товар с тем же артикулом есть в МоёмСкладе. */
  onMoySklad = 4
}
